/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
import React, {useContext, useEffect, useState} from 'react';
import * as PIXI from 'pixi.js';
import '@pixi/unsafe-eval';
import {BlurFilter, Texture} from 'pixi.js';
import {Stage, Container, Sprite, Text, useTick, useApp, AnimatedSprite} from '@pixi/react';
import {PositionContext} from '@utils/context';
import {getControlPoint, calculatePerpendicularPoint, twoBezier} from '../helper';
import {env} from 'next-runtime-env';
import useCommon from '@utils/hooks/common';
import styles from './styles';

interface StickerProps {
  onAnimationComplete: () => void;
  stageWidth: number;
  stageHeight: number;
  animation: PIXI.Texture[];
  scaleUpValue?: number;
  senderPosition: number;
  receiverPosition: number;
  canvasPosition: any;
  playerIconCenterPositions: any;
}

const Sticker = React.memo((props: StickerProps) => {
  const {classes, t, socket} = useCommon({
    withTranslation: ['table_area', 'best_combination', 'common'],
    observers: ['game', 'socket'],
  });
  const {
    stageWidth,
    stageHeight,
    onAnimationComplete,
    animation,
    scaleUpValue,
    senderPosition,
    receiverPosition,
    canvasPosition,
    playerIconCenterPositions,
  } = props;

  // TODO
  const startPosition = {
    y: playerIconCenterPositions[senderPosition]?.y - canvasPosition?.top,
    x: playerIconCenterPositions[senderPosition]?.x - canvasPosition?.left,
  };
  const endPosition = {
    y: playerIconCenterPositions[receiverPosition]?.y - canvasPosition?.top,
    x: playerIconCenterPositions[receiverPosition]?.x - canvasPosition?.left,
  };

  // TODO remember to deduct it
  const spriteInitialX = startPosition?.x;
  const spriteInitialY = startPosition?.y;
  const [isPlay, setIsPlay] = useState(false);

  const initialPoint: [number, number] = [startPosition?.x, startPosition?.y];
  const targetPoint: [number, number] = [endPosition?.x, endPosition?.y];

  const [rot, setRot] = React.useState(0);
  const [spritePosition, setSpritePosition] = useState({x: spriteInitialX, y: spriteInitialY});
  const [elapsedTime, setElapsedTime] = useState(0);

  useTick(delta => {
    // console.log('*** useTick ***');
    const animationMovementTime = 70;
    const t = Math.min(elapsedTime / animationMovementTime, 1);
    if (animation?.length !== 0) {
      setElapsedTime(prevElapsedTime => prevElapsedTime + delta);
      const controlPoint = calculatePerpendicularPoint(
        {x: startPosition.x, y: startPosition.y},
        {x: endPosition.x, y: endPosition.y},
        {width: stageWidth, height: stageHeight},
        0.5
      );
      // const controlPoint = getControlPoint(initialPoint, targetPoint, 1.5);
      // t is the finish rate of current animation
      const [xt, yt] = twoBezier({
        p1: initialPoint,
        p2: targetPoint,
        t,
        // TODO get control point
        // c1: [stageWidth, stageHeight],
        // c1: controlPoint,
        c1: [controlPoint.x, controlPoint.y],
      });
      setSpritePosition({x: xt, y: yt});
      setRot(prevRot => prevRot + 0.2 * delta);
      setIsPlay(false);
      if (t >= 1) {
        setIsPlay(true);
        // onAnimationComplete();
        setTimeout(() => {
          onAnimationComplete();
          setElapsedTime(0);
          setSpritePosition({x: null, y: null});
        }, 1000);
      }
    }
  });

  //! otherwise type error
  if (
    typeof animation === 'undefined' ||
    animation.length === 0 ||
    elapsedTime === 0 ||
    (spritePosition.x === 0 && spritePosition.y === 0) ||
    (spritePosition.x === null && spritePosition.y === null)
  ) {
    return null;
  }

  return (
    <AnimatedSprite
      height={(senderPosition === receiverPosition ? 55 * 1.1 : 55) * scaleUpValue}
      width={(senderPosition === receiverPosition ? 55 * 1.1 : 55) * scaleUpValue}
      initialFrame={0}
      textures={animation}
      anchor={0.5}
      x={spritePosition.x}
      y={spritePosition.y}
      // onComplete={onAnimationComplete}
      isPlaying={isPlay}
      rotation={senderPosition === receiverPosition ? 0 : rot}
    />
  );
});

Sticker.displayName = 'Sticker';

export default Sticker;
